import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

import { useFormCreateBrands } from '../../controllers/Brands/CreateBrandsController';
import LoadingScreen from '../../components/LoadingScreen';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

const BrandForm: React.FC = () => {
    const { getBrandFormController, handleBrandFormController } = useFormCreateBrands();
    const history = useHistory();

    const [registerFinished, setRegisterFinished] = useState(false);

    useEffect(() => {
        if (getBrandFormController.brandResponse?.status === 200) {
            setRegisterFinished(true);
        }
        if (getBrandFormController.brandEditedResponse?.status === 200 && !getBrandFormController.brandResponse) {
            setRegisterFinished(false);
        }
    }, [getBrandFormController.brandResponse, getBrandFormController.brandEditedResponse]);

    return (
        <div style={{ height: '100%' }} className="p-grid p-align-center p-justify-center">
            <Toast ref={getBrandFormController.toast} />
            {getBrandFormController.loading ? <LoadingScreen color="#0388e5" /> : <></>}
            <div className="p-col-12 p-md-8">
                <div className="card p-fluid">
                    <h5>Marca</h5>
                    <div className="p-field">
                        <label htmlFor="name">Nome</label>
                        <InputText id="name" type="text" maxLength={150} disabled={registerFinished}
                            value={getBrandFormController.formik.values.DESCRICAO}
                            onChange={getBrandFormController.formik.handleChange('DESCRICAO')}
                        />
                        <div className={classNames("p-invalid popup-fade", {
                            'popup-form-active': getBrandFormController.formik.touched.DESCRICAO && getBrandFormController.formik.errors.DESCRICAO,
                            'popup-form-inactive': !(getBrandFormController.formik.touched.DESCRICAO && getBrandFormController.formik.errors.DESCRICAO),
                        })}
                        >{getBrandFormController.formik.errors.DESCRICAO}</div>
                    </div>
                    <div className="p-fluid p-grid p-justify-between">
                        {getBrandFormController.brandResponse?.status === 200 && !registerFinished ?
                            <div className="p-col-12 p-md-4">
                                <Button
                                    type="button"
                                    label="Salvar Alterações"
                                    onClick={() => {
                                        getBrandFormController.formik.handleSubmit()
                                    }}
                                />
                            </div> :
                            getBrandFormController.brandResponse?.status === 200 && registerFinished ?
                                <div className="p-col-12 p-md-6 p-fluid p-grid" >
                                    <div className="p-col-12 p-md-5">
                                        <Button
                                            type="button"
                                            label="Editar"
                                            onClick={() => {
                                                setRegisterFinished(false);
                                            }}
                                        />
                                    </div>
                                    <div className="p-col-12 p-md-5" >
                                        <Button
                                            icon="pi pi-plus"
                                            type="button"
                                            className="p-button-success"
                                            label="Cadastrar novo"
                                            onClick={() => {
                                                getBrandFormController.formik.resetForm();
                                                setRegisterFinished(false);
                                                handleBrandFormController.setBrandResponse(null);
                                            }}
                                        />
                                    </div>
                                </div> :
                                <div className="p-col-12 p-md-4">
                                    <Button
                                        type="button"
                                        label="Cadastrar"
                                        onClick={() => getBrandFormController.formik.handleSubmit()}
                                    />
                                </div>
                        }

                        <div className="p-col-12 p-md-4">
                            <Button
                                type="button"
                                className="p-button-secondary"
                                label="Voltar para listagem"
                                onClick={() => history.goBack()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default BrandForm;